module.exports = ['$scope', 'ngMeta',
  function ($scope, ngMeta) {
    'use strict';
    ngMeta.setTitle('Concept: krachtlijnen');

    $scope.$parent.loadedPromise.then(function (document) {
      $scope.document = document;
    });

  }];



// WEBPACK FOOTER //
// ./web/js/screen/concept/krachtlijnen/home/conceptKrachtlijnenHomeController.js